<ng-container *ngIf="product$ | async as product">
  <ng-container *ngFor="let pkg of product.packages; trackBy: trackByPackageId">
    <mat-card [ngClass]="{'disabled': pkg.statusCode =='VESS'}" [class.selected]="isSelected(pkg)" (click)="onSelectedCard(pkg)">
      <app-package-card [package]="pkg" [cart]="cart" [currency]="currency" [internalUser]="internalUser"></app-package-card>
    </mat-card>
  </ng-container>
</ng-container>
